<template lang="pug">
  .tags-summary-table
    summary-table.scrollable(:dateRange="dateRange"
                  report="conversations_per_tag"
                  :selectedFilters="filters"
                  breakdown="day"
                  :selectable="false"
                  :items="items"
                  @onDataChange="onDataChange")
        slot
          aiq-table-column(label="Tag", prop="tag_name" min-width="200" label-class-name="is-bordered" :sortable="true")
            template(v-slot:default="scope")
              aiq-button(link type="primary" size="small", @click="goToConversation(scope.row)") {{ scope.row.tag_name }}
          aiq-table-column(label="Last Used Date" prop="last_used" width="200" :sortable="true" label-class-name="is-bordered" :formatter="formatDate")
          aiq-table-column(label="Total Uses", prop="conversations_per_tag" width="150" :sortable="true" label-class-name="is-bordered" align="center")

</template>

<script>
import get from 'lodash/get';
import SummaryTable from '../../../SummaryTable.vue';
import { downloadAsFile, useTimeZone, getMetricsTimeZoneAbbr, formatDateWithTimezone } from '@/libs';

export default {
  name: 'summaryMetricsSummaryTable',
  components: {
    SummaryTable,
  },
  props: {
    dateRange: {
      required: true,
      type: Array,
    },
    query: {
      required: false,
      type: String,
    },
    filters: {
      type: Array,
    },
    namedFilters: {
      type: Object,
    },
  },
  data() {
    return {
      chartData: null,
      items: [],
      selection: [],
      named: this.namedFilters,
      timezone: '',
      tzAbbr: '',
    };
  },
  async mounted() {
    this.timezone = await useTimeZone(
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      this.$store.dispatch,
      this.$store._state.data.configs,
    );
    this.tzAbbr = getMetricsTimeZoneAbbr(this.timezone);
  },
  methods: {
    onDataChange(data = {}) {
      const dataPoints = get(data, 'dataset.0.data_points', []);
      this.items = dataPoints.sort((a, b) => (b.conversations_per_tag || 0) - (a.conversations_per_tag || 0));
    },
    exportTable(filename) {
      const dataPoints = this.items.map(item => ({
        'Tag': item.tag_name,
        'Last Used Date': item.last_used ? this.formatDate(item) : '',
        'Total Uses': item.conversations_per_tag || 0,
      }));
      downloadAsFile({
        filename,
        dataType: 'table',
        dataSource: 'metrics',
        data: dataPoints,
      });
    },
    goToConversation(item) {
      const customer_segments = get(this.namedFilters, 'customer_segments');
      const teams = get(this.namedFilters, 'teams');

      if (this.canView('/conversations')) {
        this.$router.push({
          name: 'ConversationByCustomerId',
          query: {
            tag_names: item.tag_name,
            date_range: this.dateRange,
            customer_segments,
            teams,
          },
          state: { forceSelectAllTab: true },
        });
      }
    },
    formatDate(row) {
      if (!row.last_used) return '';
      return `${formatDateWithTimezone(row.last_used, this.timezone, 'MMM DD, YYYY hh:mm A')} ${this.tzAbbr}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-inner {
  padding: 0;
}

.el-tag {
  margin: 0 4px 1px 0;
}
</style>

<style lang="scss">
@import "../../../../../styles/aiq-mixins.scss";

.tags-summary-table {
  .scrollable .el-table__body-wrapper {
    @include scrollable(calc(100vh - 257px));
  }
}
</style>
